(function() {
  if (!document.body.classList.contains('template-index')) {
    return;
  }

  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  document.querySelectorAll('.soteak-reveal').forEach(function(node) {
    if (node.closest('.soteak-home-hero')) {
      window.setTimeout(function() {
        node.classList.add('is-visible');
      }, 160);
    } else {
      revealObserver.observe(node);
    }
  });

  var heroImage = document.querySelector('[data-soteak-hero-media]');
  var heroSection = document.querySelector('.soteak-home-hero');

  if (heroImage && heroSection) {
    window.addEventListener('scroll', function() {
      var offset = window.pageYOffset || document.documentElement.scrollTop;
      var heroHeight = heroSection.offsetHeight;
      if (offset < heroHeight * 1.2) {
        heroImage.style.transform = 'translateY(' + (offset * 0.22) + 'px)';
      }
    }, { passive: true });
  }
})();
